import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useCloseModalRestriction = () => {
  const { onOpenModal, onResetModal } = useModal();
    const { t } = useTranslation('target');

  const onCloseRestriction = ({ submit }) => {
    onOpenModal({
      width: '600px',
      maxWidth: '600px',
      isOpen: true,
      type: 'cancel',
      title: t("cancelModal.title"),
      contentDescription: t("cancelModal.description"),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t("cancelModal.primaryButton"),
      secondaryButtonText: t("cancelModal.secondaryButton"),
      onClickPrimaryButton: () => {
        submit();
        onResetModal();
      },
    });
  };

  return { onCloseRestriction };
};

export default useCloseModalRestriction;
